import script from "./AppCookiesAgreement.vue?vue&type=script&setup=true&lang=js"
export * from "./AppCookiesAgreement.vue?vue&type=script&setup=true&lang=js"

import "./AppCookiesAgreement.vue?vue&type=style&index=0&id=391ddc08&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-391ddc08"]])

export default __exports__